import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

import { LoadingScreen } from "@/components/ProtectedRoute";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash.substring(1);
    const sessionId = new URLSearchParams(hash).get("session_id");
    if (!sessionId) {
      navigate("/auth", { replace: true });
      return;
    }
    api
      .post("/auth/google/session", { session_id: sessionId })
      .then((r) => {
        setUser(r.data);
        window.history.replaceState(null, "", window.location.pathname);
        navigate(r.data.role ? "/dashboard" : "/completar-perfil", { replace: true, state: { user: r.data } });
      })
      .catch(() => navigate("/auth", { replace: true }));
  }, [navigate, setUser]);

  return <LoadingScreen />;
}
